// Axios (opcional si ya lo tienes en otro lugar)
window._ = require('lodash');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Bootstrap 5: importa el bundle (trae Popper incluido)
require('bootstrap/dist/js/bootstrap.bundle.js');
// Si necesitas los estilos por JS (opcional, normalmente vas por SASS/CSS):
// require('bootstrap/dist/css/bootstrap.min.css');
